(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-about"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-about')) {
    class SssAbout extends HTMLElement {
      connectedCallback() {
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setupHero();
        this.setupReveal();
        this.setupField();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onRead, { capture: true });
        this.io?.disconnect();
        this.fieldIo?.disconnect();
        this.ro?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      /* Hero: the button and ring glide down to the story, and the ring fills
         with how far down the page you are. Dwell scrolls .page-wrapper on
         desktop and the window on phones, so both are handled. */
      setupHero() {
        const story = this.querySelector('#SssStory');
        this.querySelectorAll('[data-to-story]').forEach((a) =>
          a.addEventListener('click', (e) => {
            if (!story) return;
            e.preventDefault();
            story.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
          })
        );

        const ring = this.querySelector('.sss-ab__scroll');
        if (!ring) return;
        const scroller = () => {
          const w = document.querySelector('.page-wrapper');
          return w && w.scrollHeight > w.clientHeight + 1 ? w : document.scrollingElement;
        };
        let queued = false;
        this.onRead = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            const el = scroller();
            const max = el.scrollHeight - el.clientHeight;
            const read = max > 0 ? Math.min(1, Math.max(0, el.scrollTop / max)) : 0;
            ring.style.setProperty('--read', read.toFixed(4));
          });
        };
        document.addEventListener('scroll', this.onRead, { passive: true, capture: true });
        this.onRead();
      }

      /* Photos, figures and cards rise in once; the figures count up. */
      setupReveal() {
        const items = [...this.querySelectorAll('[data-reveal]')];
        const show = (el) => {
          if (el.classList.contains('is-in')) return;
          el.classList.add('is-in');
          el.querySelectorAll('[data-count]').forEach((n) => this.count(n));
        };
        if (this.reduced || !('IntersectionObserver' in window)) {
          items.forEach(show);
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => entries.forEach((e) => {
            if (e.isIntersecting) {
              show(e.target);
              this.io.unobserve(e.target);
            }
          }),
          { rootMargin: '0px 0px -12% 0px' }
        );
        items.forEach((el) => this.io.observe(el));
      }

      count(el) {
        const target = parseFloat(el.dataset.count);
        if (!Number.isFinite(target) || this.reduced) return;
        const start = performance.now();
        const dur = 1400;
        const step = (t) => {
          const k = Math.min(1, (t - start) / dur);
          const eased = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(target * eased);
          if (k < 1) requestAnimationFrame(step);
        };
        el.textContent = '0';
        requestAnimationFrame(step);
        // Never leave a figure stuck mid-count.
        setTimeout(() => (el.textContent = el.dataset.count), dur + 400);
      }

      /* Closing field: perforation dots that warm to gold around the cursor,
         drifting on their own when there is no cursor. */
      setupField() {
        const canvas = this.querySelector('[data-field]');
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        const area = canvas.parentElement;
        let w = 0;
        let h = 0;
        let light = null;
        let target = { x: 0, y: 0 };
        let hovering = false;
        let running = false;

        const draw = () => {
          if (!w || !h) return;
          ctx.clearRect(0, 0, w, h);
          const gap = 14;
          const reach = Math.max(140, Math.min(280, Math.min(w, h) * 0.5));
          const glow = ctx.createRadialGradient(light.x, light.y, 0, light.x, light.y, reach * 1.25);
          glow.addColorStop(0, 'rgba(232, 186, 110, 0.28)');
          glow.addColorStop(1, 'rgba(232, 186, 110, 0)');
          ctx.fillStyle = glow;
          ctx.fillRect(0, 0, w, h);

          const ox = (w % gap) / 2;
          const oy = (h % gap) / 2;
          const lit = [];
          ctx.fillStyle = 'rgba(36, 30, 24, 0.16)';
          ctx.beginPath();
          for (let y = oy; y <= h; y += gap) {
            for (let x = ox; x <= w; x += gap) {
              const d = Math.hypot(x - light.x, y - light.y);
              const k = d < reach ? (1 - d / reach) ** 2 : 0;
              if (k < 0.03) {
                ctx.moveTo(x + 1.1, y);
                ctx.arc(x, y, 1.1, 0, Math.PI * 2);
              } else {
                lit.push(x, y, k);
              }
            }
          }
          ctx.fill();
          for (let i = 0; i < lit.length; i += 3) {
            const k = lit[i + 2];
            ctx.fillStyle = `rgba(184, 150, 90, ${(0.3 + 0.7 * k).toFixed(3)})`;
            ctx.beginPath();
            ctx.arc(lit[i], lit[i + 1], 1.1 + 1.9 * k, 0, Math.PI * 2);
            ctx.fill();
          }
        };

        const resize = () => {
          const r = canvas.getBoundingClientRect();
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          w = r.width;
          h = r.height;
          canvas.width = Math.round(w * dpr);
          canvas.height = Math.round(h * dpr);
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          if (!light) light = { x: w * 0.5, y: h * 0.5 };
          draw();
        };
        this.ro = new ResizeObserver(resize);
        this.ro.observe(canvas);
        if (this.reduced) return;

        area.addEventListener('pointermove', (e) => {
          const r = canvas.getBoundingClientRect();
          target = { x: e.clientX - r.left, y: e.clientY - r.top };
          hovering = true;
        });
        area.addEventListener('pointerleave', () => (hovering = false));

        const loop = (t) => {
          if (!running) return;
          if (!hovering) {
            target = {
              x: w * (0.5 + 0.3 * Math.sin(t / 4400)),
              y: h * (0.5 + 0.22 * Math.sin(t / 3200 + 1)),
            };
          }
          light.x += (target.x - light.x) * 0.08;
          light.y += (target.y - light.y) * 0.08;
          draw();
          this.frame = requestAnimationFrame(loop);
        };

        this.fieldIo = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && !running && light) {
            running = true;
            this.frame = requestAnimationFrame(loop);
          } else if (!entry.isIntersecting) {
            running = false;
            cancelAnimationFrame(this.frame);
          }
        });
        this.fieldIo.observe(area);
      }
    }

    customElements.define('sss-about', SssAbout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-collection"]) return;
  try {
    
  if (!customElements.get('sss-collection')) {
    class SssCollection extends HTMLElement {
      connectedCallback() {
        const cards = [...this.querySelectorAll('.sss-plp__card')];

        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (!e.isIntersecting) return;
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              });
            },
            { rootMargin: '0px 0px -8% 0px' }
          );
          cards.forEach((c) => io.observe(c));
        }
        // Throttled frames in background tabs must not leave cards hidden.
        setTimeout(() => cards.forEach((c) => c.classList.add('is-in')), 2500);

        const sort = this.querySelector('.sss-plp__sort');
        document.addEventListener('click', (event) => {
          if (sort?.open && !sort.contains(event.target)) sort.open = false;
        });
      }
    }

    customElements.define('sss-collection', SssCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-compare')) {
    class SssCompare extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-frame]');
        this.handle = this.querySelector('[data-handle]');
        if (!this.frame) return;

        let dragging = false;
        const fromEvent = (e) => {
          const r = this.frame.getBoundingClientRect();
          this.set(((e.clientX - r.left) / r.width) * 100);
        };

        this.frame.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          dragging = true;
          this.frame.classList.remove('is-gliding');
          this.frame.classList.add('is-dragging');
          this.frame.setPointerCapture(e.pointerId);
          fromEvent(e);
        });
        this.frame.addEventListener('pointermove', (e) => dragging && fromEvent(e));
        const end = () => {
          dragging = false;
          this.frame.classList.remove('is-dragging');
        };
        this.frame.addEventListener('pointerup', end);
        this.frame.addEventListener('pointercancel', end);

        this.handle?.addEventListener('keydown', (e) => {
          const step = e.shiftKey ? 10 : 4;
          if (e.key === 'ArrowLeft') this.set(this.pos - step);
          else if (e.key === 'ArrowRight') this.set(this.pos + step);
          else if (e.key === 'Home') this.set(0);
          else if (e.key === 'End') this.set(100);
          else return;
          e.preventDefault();
        });

        this.set(50);

        // Each reason lights its dot on the photo while it's hovered, focused
        // or tapped.
        this.spots = [...this.querySelectorAll('[data-spot]')];
        this.notes = [...this.querySelectorAll('[data-note]')];
        this.notes.forEach((note) => {
          const i = Number(note.dataset.note);
          note.addEventListener('mouseenter', () => this.openSpot(i));
          note.addEventListener('mouseleave', () => this.openSpot(-1));
          note.addEventListener('focus', () => this.openSpot(i));
          note.addEventListener('blur', () => this.openSpot(-1));
          note.addEventListener('click', () => this.openSpot(i));
          note.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.openSpot(i);
            }
          });
        });
        document.addEventListener('click', (e) => {
          if (!(e.target instanceof Element)) return;
          if (e.target.closest('.sss-ba__note')) return;
          this.openSpot(-1);
        });

        // First time it is seen: reveal the notes and nudge the handle once.
        const reveal = () => {
          if (this.revealed) return;
          this.revealed = true;
          this.classList.add('is-in');
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const seq = [64, 38, 50];
          let i = 0;
          this.frame.classList.add('is-gliding');
          const next = () => {
            if (i >= seq.length || this.frame.classList.contains('is-dragging')) {
              this.frame.classList.remove('is-gliding');
              return;
            }
            this.set(seq[i++]);
            setTimeout(next, 950);
          };
          setTimeout(next, 400);
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                reveal();
                io.disconnect();
              }
            },
            { threshold: 0.45 }
          );
          io.observe(this.frame);
        } else {
          reveal();
        }
      }

      openSpot(index) {
        this.spots?.forEach((s, i) => s.classList.toggle('is-open', i === index));
        this.notes?.forEach((n) => n.classList.toggle('is-active', Number(n.dataset.note) === index));
      }

      set(v) {
        this.pos = Math.max(0, Math.min(100, v));
        this.frame.style.setProperty('--pos', this.pos + '%');
        this.handle?.setAttribute('aria-valuenow', String(Math.round(this.pos)));
      }
    }

    customElements.define('sss-compare', SssCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-footer')) {
    class SssFooter extends HTMLElement {
      connectedCallback() {
        const show = () => this.classList.add('is-in');
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                show();
                io.disconnect();
              }
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          io.observe(this);
        } else {
          show();
        }

        // Phones: a column's heading folds and unfolds its links.
        this.addEventListener('click', (event) => {
          const toggle = event.target instanceof Element && event.target.closest('[data-ft-toggle]');
          if (!toggle) return;
          const open = toggle.closest('.sss-ft__col').classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
        });
      }
    }

    customElements.define('sss-footer', SssFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-hero"] && !Shopify.designMode) return;
  try {
    
  class SssHero extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.sss-hero__image');
      this.goShop();

      // The reduced-motion check lives here as well as in CSS so the parallax
      // listener is never attached at all for a visitor who has asked for less
      // motion — a media query would still have left it running.
      this.setupSlideshow();

      this.motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.motionOk) return;

      // Only now is the hidden entrance state applied. Before this attribute
      // exists the content is simply visible, so a failure to load this script
      // leaves a working hero rather than a blank one.
      this.setAttribute('data-motion', '');

      this.stagger();
      this.reveal();
      this.parallax();
    }

    /* ---- Slideshow ---------------------------------------------------------
       Runs whether or not motion is allowed: with reduced motion there is no
       autoplay and no ring, but the numbers still switch slides. */
    setupSlideshow() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.classList.toggle('is-video', !!this.slides[0]?.hasAttribute('data-video-slide'));
      this.autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // A single slide that is a video simply plays on a loop.
      if (this.slides.length === 1) {
        if (this.autoplay) this.videoIn(this.slides[0])?.play().catch(() => {});
        return;
      }
      if (this.slides.length < 2) return;

      this.nums = [...this.querySelectorAll('[data-goto]')];
      this.ring = this.querySelector('[data-ring]');
      this.current = 0;
      this.interval = (parseFloat(getComputedStyle(this).getPropertyValue('--sss-hero-interval')) || 6) * 1000;
      // Once the first slide has had the network to itself, start on the next.
      setTimeout(() => this.wake(this.slides[1]), 2500);

      this.nums.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.goTo(Number(btn.dataset.goto));
        });
      });

      this.bindSwipe();
      this.bindVisibility();
      this.startCycle();
    }

    goTo(index) {
      const count = this.slides.length;
      const next = ((index % count) + count) % count;
      if (next === this.current) {
        this.startCycle();
        return;
      }

      const outgoing = this.slides[this.current];
      const incoming = this.slides[next];

      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      // Let a video keep moving through the dissolve, then stop and rewind it.
      const outVideo = this.videoIn(outgoing);
      if (outVideo) setTimeout(() => { outVideo.pause(); outVideo.currentTime = 0; }, 1400);
      outgoing.setAttribute('aria-hidden', 'true');
      // Lazy slides load as they come up rather than all at page load.
      this.wake(incoming);
      incoming.classList.add('is-active');
      incoming.removeAttribute('aria-hidden');
      this.classList.toggle('is-video', incoming.hasAttribute('data-video-slide'));
      this.showLine(next);
      setTimeout(() => outgoing.classList.remove('is-leaving'), 1400);

      this.nums.forEach((btn, i) => {
        btn.classList.toggle('is-active', i === next);
        if (i === next) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });

      this.current = next;
      // Warm the slide after this one so it is decoded before it is needed.
      this.wake(this.slides[(next + 1) % count]);
      this.startCycle();
    }

    /* Crossfade the shopping line to the one for slide i. */
    showLine(i) {
      [...this.querySelectorAll('.sss-hero__shop [data-line]')].forEach((line, n) => {
        line.classList.toggle('is-active', n === i);
        line.querySelector('a')?.setAttribute('tabindex', n === i ? '0' : '-1');
      });
    }

    /* The video showing in a slide (the desktop or the mobile one, whichever
       is displayed at this screen size), if the slide is a video. */
    /* Start a slide's photograph loading: only the crop this screen shows, so
       a phone never fetches the landscape one (nor a desktop the portrait). */
    wake(slide) {
      slide.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        if (getComputedStyle(img).display !== 'none') img.loading = 'eager';
      });
      slide.querySelectorAll('video[preload="none"]').forEach((video) => {
        if (getComputedStyle(video).display === 'none') return;
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.preload = 'auto';
      });
    }

    videoIn(slide) {
      if (!slide) return null;
      const vids = [...slide.querySelectorAll('video')];
      return vids.find((v) => getComputedStyle(v).display !== 'none') || null;
    }

    startCycle() {
      clearTimeout(this.timer);
      this.detachVideo();

      // A video slide is timed by the video itself (see runVideo); a
      // photograph uses the section's "Seconds per slide".
      const video = this.videoIn(this.slides[this.current]);
      if (video && this.autoplay) {
        this.runVideo(video);
        return;
      }

      const duration = this.interval;
      if (this.ring) {
        // Restart the ring: remove the class, force a reflow, add it back.
        this.ring.style.animationDuration = '';
        this.ring.classList.remove('is-running');
        void this.ring.getBoundingClientRect();
        if (this.autoplay) this.ring.classList.add('is-running');
      }
      if (!this.autoplay || this.hasAttribute('data-paused')) {
        this.remaining = duration;
        return;
      }
      this.timer = setTimeout(() => this.goTo(this.current + 1), duration);
      this.cycleStarted = performance.now();
      this.remaining = duration;
    }

    /* Video slides. A separate timer would start the moment the slide appears,
       while the video only starts once it has buffered — so the timer ran
       past the end and the looping video jumped back to its first frame
       before the switch. Instead the video plays once (no loop) and the
       slideshow moves on as it reaches its last frame. The ring is started
       when playback actually begins and holds still while it buffers. */
    runVideo(video) {
      this.video = video;
      video.loop = false;
      video.currentTime = 0;
      let ringStarted = false;
      let done = false;

      const startRing = () => {
        if (ringStarted || !this.ring || !Number.isFinite(video.duration)) return;
        ringStarted = true;
        this.ring.style.animationDuration = Math.max(0.5, video.duration - video.currentTime) * 1000 + 'ms';
        this.ring.classList.remove('is-running');
        void this.ring.getBoundingClientRect();
        this.ring.classList.add('is-running');
      };
      const advance = () => {
        if (done) return;
        done = true;
        this.goTo(this.current + 1);
      };

      this.videoHandlers = {
        playing: () => {
          this.removeAttribute('data-buffering');
          startRing();
        },
        waiting: () => this.setAttribute('data-buffering', ''),
        // A fraction of a second early, so the dissolve starts on the last
        // frames rather than on a frozen end frame.
        timeupdate: () => {
          if (Number.isFinite(video.duration) && video.currentTime >= video.duration - 0.25) advance();
        },
        ended: advance,
        // If the video cannot play, fall back to an ordinary timed slide.
        error: () => {
          this.detachVideo();
          this.timer = setTimeout(() => this.goTo(this.current + 1), this.interval);
        },
      };
      Object.entries(this.videoHandlers).forEach(([type, fn]) => video.addEventListener(type, fn));

      if (this.ring) this.ring.classList.remove('is-running');
      // Only a real refusal (autoplay blocked, e.g. iPhone Low Power Mode)
      // falls back to a timed slide; an interrupted play is simply retried
      // when the hero is next resumed.
      if (!this.hasAttribute('data-paused')) {
        video.play().catch((e) => {
          if (e && e.name === 'NotAllowedError') this.videoHandlers?.error();
        });
      }
    }

    detachVideo() {
      if (!this.video || !this.videoHandlers) {
        this.video = null;
        return;
      }
      Object.entries(this.videoHandlers).forEach(([type, fn]) => this.video.removeEventListener(type, fn));
      this.removeAttribute('data-buffering');
      this.video = null;
      this.videoHandlers = null;
    }

    pause() {
      if (this.hasAttribute('data-paused')) return;
      this.setAttribute('data-paused', '');
      clearTimeout(this.timer);
      if (this.video) {
        this.video.pause();
        return;
      }
      if (this.cycleStarted) this.remaining = Math.max(0, this.remaining - (performance.now() - this.cycleStarted));
    }

    resume() {
      if (!this.hasAttribute('data-paused')) return;
      this.removeAttribute('data-paused');
      if (!this.autoplay) return;
      if (this.video) {
        this.video.play().catch(() => {});
        return;
      }
      this.cycleStarted = performance.now();
      this.timer = setTimeout(() => this.goTo(this.current + 1), this.remaining ?? this.interval);
    }

    /* Pause while the hero is off-screen or the tab is hidden, so slides do not
       advance unseen and the ring is where it was when you come back. */
    bindVisibility() {
      let onScreen = true;
      const sync = () => (onScreen && !document.hidden ? this.resume() : this.pause());
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          onScreen = entry.isIntersecting;
          sync();
        }, { threshold: 0.2 }).observe(this);
      }
      document.addEventListener('visibilitychange', sync);
    }

    /* Touch drag: the photo follows the finger and the next (or previous)
       slide slides in beside it, like flicking through a stack of prints.
       Let go past a fifth of the width (or with a quick flick) and it carries
       on to that slide; otherwise it springs back. Vertical movement is left
       to the page (touch-action: pan-y), so scrolling past the hero is
       unchanged. */
    bindSwipe() {
      const count = this.slides.length;
      if (count < 2) return;
      let startX = 0;
      let startY = 0;
      let startT = 0;
      let dx = 0;
      let mode = null; // null: undecided, 'drag', or 'scroll'
      let pid = null;
      let target = null;
      let dir = 0;
      let width = 0;
      let busy = false;
      this.suppressClick = false;

      const scaleOf = () => (window.matchMedia('(min-width: 990px)').matches ? '' : ' scale(1.06)');
      const place = (el, x, animate) => {
        el.style.transition = animate ? 'transform 0.38s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
        el.style.transform = `translate3d(${x}px, 0, 0)${scaleOf()}`;
      };
      const clear = (el) => {
        if (!el) return;
        el.style.transition = '';
        el.style.transform = '';
        el.style.opacity = '';
        el.style.zIndex = '';
      };
      const neighbour = (d) => this.slides[(((this.current + d) % count) + count) % count];

      this.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' || busy) return;
        pid = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startT = performance.now();
        dx = 0;
        mode = null;
        target = null;
        dir = 0;
        width = this.getBoundingClientRect().width;
      }, { passive: true });

      this.addEventListener('pointermove', (e) => {
        if (e.pointerId !== pid || mode === 'scroll' || busy) return;
        const mx = e.clientX - startX;
        const my = e.clientY - startY;
        if (mode === null) {
          if (Math.abs(my) > 8 && Math.abs(my) > Math.abs(mx)) { mode = 'scroll'; return; }
          if (Math.abs(mx) < 8) return;
          mode = 'drag';
          clearTimeout(this.timer);
          this.ring?.classList.remove('is-running');
        }
        dx = mx;
        const d = dx < 0 ? 1 : -1;
        if (d !== dir) {
          if (target) clear(target);
          dir = d;
          target = neighbour(d);
          this.wake(target);
          target.style.opacity = '1';
          target.style.zIndex = '3';
        }
        const cur = this.slides[this.current];
        cur.style.zIndex = '2';
        place(cur, dx, false);
        place(target, dx + (dir === 1 ? width : -width), false);
      }, { passive: true });

      const end = (e) => {
        if (e.pointerId !== pid) return;
        pid = null;
        if (mode !== 'drag' || !target) { mode = null; return; }
        mode = null;
        this.suppressClick = true;
        setTimeout(() => (this.suppressClick = false), 400);
        const cur = this.slides[this.current];
        const fast = Math.abs(dx) / Math.max(1, performance.now() - startT) > 0.45;
        const go = e.type !== 'pointercancel' && (Math.abs(dx) > width * 0.2 || (fast && Math.abs(dx) > 30));
        const incoming = target;
        const step = dir;
        busy = true;
        if (go) {
          place(cur, dir === 1 ? -width : width, true);
          place(incoming, 0, true);
        } else {
          place(cur, 0, true);
          place(incoming, dir === 1 ? width : -width, true);
        }
        setTimeout(() => {
          // Swap the classes with the slides' fade switched off, so nothing
          // dissolves over the picture that has just slid into place.
          this.setAttribute('data-instant', '');
          if (go) this.goTo(this.current + step);
          else this.startCycle();
          clear(cur);
          clear(incoming);
          requestAnimationFrame(() => requestAnimationFrame(() => this.removeAttribute('data-instant')));
          target = null;
          dir = 0;
          busy = false;
        }, 400);
      };
      this.addEventListener('pointerup', end, { passive: true });
      this.addEventListener('pointercancel', end, { passive: true });

      // A drag that ends over the shop button is not a tap on it.
      this.addEventListener('click', (e) => {
        if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    stagger() {
      // Order matters more than the numbers: eyebrow, then each headline line,
      // then the annotations as a group, then the button. Reading order.
      const sequence = [
        ...this.querySelectorAll('.sss-hero__eyebrow'),
        ...this.querySelectorAll('.sss-hero__line'),
        ...this.querySelectorAll('.sss-hero__annotation'),
        ...this.querySelectorAll('.sss-hero__cta'),
      ];
      sequence.forEach((el, i) => {
        el.style.setProperty('--reveal-delay', `${i * 90}ms`);
      });
    }

    reveal() {
      // The hero sits at the top of the page, so in practice this fires
      // immediately — but going through the observer means the same section
      // still behaves correctly if it is ever moved down the page.
      const show = () => this.setAttribute('data-revealed', '');

      if (!('IntersectionObserver' in window)) {
        show();
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            // Two frames: one for the hidden state to paint, one for the
            // transition to have something to animate from. Without this the
            // browser coalesces both states and nothing moves.
            requestAnimationFrame(() => requestAnimationFrame(show));
            // rAF is throttled to a standstill in a background tab, which would
            // otherwise leave the hero blank for as long as the tab stays
            // hidden. The timeout is the floor: worst case the entrance is
            // skipped, never the content.
            setTimeout(show, 600);
            io.disconnect();
          }
        },
        { threshold: 0.12 }
      );
      io.observe(this);
    }

    parallax() {
      if (!this.media) return;

      let ticking = false;

      const update = () => {
        ticking = false;
        const rect = this.getBoundingClientRect();
        // Skip the maths entirely when the section is off-screen.
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;

        // -1 to 1 across the section's travel through the viewport.
        const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
        // 34px of total travel. Enough to register as depth, small enough that
        // nobody consciously notices it moving — past about 60px it starts to
        // look like the layout is broken.
        this.style.setProperty('--parallax', `${(-progress * 42).toFixed(2)}px`);
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      // Capturing listener on document, not window: Dwell scrolls the page
      // inside .page-wrapper, so window never receives a scroll event and the
      // parallax silently never ran.
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll, { passive: true });
      this.addEventListener('sss:disconnect', () => {
        document.removeEventListener('scroll', onScroll, { capture: true });
        window.removeEventListener('resize', onScroll);
      });
      update();
    }

    /* The shop button plays its press effect (gold pop, arrow shooting off)
       before the shop page opens, so the tap reads as "going there". A
       new-tab click, or a visitor who asked for less motion, goes straight. */
    goShop() {
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('.sss-hero__offer-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          if (still || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          e.preventDefault();
          btn.classList.remove('is-going');
          void btn.offsetWidth;
          btn.classList.add('is-going');
          setTimeout(() => { window.location.href = btn.href; }, 180);
        });
        // Start fetching the shop page as soon as a finger (or the mouse)
        // goes down on the button, so it is mostly loaded by the time the
        // press effect ends. Chrome also pre-renders it outright.
        const warm = () => {
          if (btn.dataset.warmed) return;
          btn.dataset.warmed = '1';
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = btn.href;
          document.head.appendChild(link);
          if (HTMLScriptElement.supports?.('speculationrules')) {
            const rules = document.createElement('script');
            rules.type = 'speculationrules';
            rules.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: [btn.href] }] });
            document.head.appendChild(rules);
          }
        };
        btn.addEventListener('pointerdown', warm, { passive: true });
        btn.addEventListener('mouseenter', warm, { passive: true });
      });
      // Coming Back from the shop page restores this page as it was: clear
      // the pressed look so the button is not left gold.
      window.addEventListener('pageshow', () => {
        this.querySelectorAll('.sss-hero__offer-btn.is-going').forEach((b) => b.classList.remove('is-going'));
      });
    }

    disconnectedCallback() {
      this.dispatchEvent(new CustomEvent('sss:disconnect'));
    }
  }

  if (!customElements.get('sss-hero')) {
    customElements.define('sss-hero', SssHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-insta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-insta')) {
    class SssInsta extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-dialog]');
        this.panel = this.querySelector('[data-panel]');

        this.querySelectorAll('[data-open]').forEach((btn) =>
          btn.addEventListener('click', () => this.open(btn.dataset.open, btn))
        );
        this.querySelector('[data-close]')?.addEventListener('click', () => this.close());

        // Touch has no hover: the first tap on a dot shows its card, the second
        // follows the link. A tap anywhere else closes any open card.
        const coarse = matchMedia('(hover: none)');
        this.querySelectorAll('[data-spot]').forEach((spot) =>
          spot.addEventListener('click', (e) => {
            if (!coarse.matches || spot.classList.contains('is-open')) return;
            e.preventDefault();
            this.querySelectorAll('[data-spot].is-open').forEach((s) => s.classList.remove('is-open'));
            spot.classList.add('is-open');
          })
        );
        document.addEventListener('click', (e) => {
          if (e.target instanceof Element && e.target.closest('[data-spot]')) return;
          this.querySelectorAll('[data-spot].is-open').forEach((s) => s.classList.remove('is-open'));
        });

        // Click on the blurred area (the dialog itself, not the panes) closes.
        this.dialog?.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });
        this.dialog?.addEventListener('close', () => {
          this.panel.replaceChildren();
          this.opener?.focus({ preventScroll: true });
        });

        // Picking a size arms the Add to cart under it. Adding: let the add go
        // out, then close so the cart can open.
        this.panel?.addEventListener('click', (e) => {
          const size = e.target.closest('[data-ig-size]:not([disabled])');
          if (size) {
            const item = size.closest('.sss-ig__product');
            item.querySelectorAll('[data-ig-size]').forEach((b) => b.setAttribute('aria-pressed', String(b === size)));
            const add = item.querySelector('.sss-ig__add');
            add.dataset.variantId = size.dataset.variantId;
            add.disabled = false;
            add.querySelector('[data-ig-add-size]').textContent = size.textContent.trim();
            item.classList.add('is-chosen');
            return;
          }
          if (e.target.closest('[data-quick-size]:not([disabled])')) setTimeout(() => this.close(), 0);
        });

        const show = () => this.classList.add('is-in');
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                show();
                io.disconnect();
              }
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          io.observe(this);
        }
        setTimeout(show, 2500);

        // A reel in the grid shows its poster until it is scrolled near, then
        // loads and plays; out of view it pauses. (As an autoplaying video it
        // downloaded with the page, long before anyone reached this section.)
        const reels = this.querySelectorAll('video.sss-ig__media');
        if (reels.length && 'IntersectionObserver' in window) {
          const watch = new IntersectionObserver(
            (entries) =>
              entries.forEach((e) => {
                if (e.isIntersecting) e.target.play().catch(() => {});
                else e.target.pause();
              }),
            { rootMargin: '200px 0px' }
          );
          reels.forEach((v) => watch.observe(v));
        } else {
          reels.forEach((v) => v.play().catch(() => {}));
        }
      }

      open(id, opener) {
        const tpl = this.querySelector(`template[data-post="${id}"]`);
        if (!tpl || !this.dialog) return;
        this.opener = opener;
        this.panel.replaceChildren(tpl.content.cloneNode(true));
        this.wire();
        this.dialog.showModal();
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
      }

      wire() {
        const slides = this.panel.querySelector('[data-slides]');
        const dots = [...this.panel.querySelectorAll('[data-dots] span')];
        if (slides) {
          slides.addEventListener(
            'scroll',
            () => {
              const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
              dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
            },
            { passive: true }
          );
          this.panel.querySelectorAll('[data-step]').forEach((b) =>
            b.addEventListener('click', () =>
              slides.scrollBy({ left: Number(b.dataset.step) * slides.clientWidth, behavior: 'smooth' })
            )
          );
        }

        const video = this.panel.querySelector('video');
        const sound = this.panel.querySelector('[data-sound]');
        video?.play?.().catch(() => {});
        sound?.addEventListener('click', () => {
          if (!video) return;
          video.muted = !video.muted;
          sound.setAttribute('aria-pressed', String(!video.muted));
          sound.setAttribute('aria-label', video.muted ? 'Sound on' : 'Sound off');
        });
      }
    }

    customElements.define('sss-insta', SssInsta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-print-index"] && !Shopify.designMode) return;
  try {
    
  class SssPrintIndex extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-pi-item]')];
      this.slides = [...this.querySelectorAll('[data-pi-slide]')];
      this.count = this.querySelector('[data-pi-count]');
      this.panel = this.querySelector('.sss-pi__panel');
      if (!this.items.length) return;

      this.active = 0;
      this.setActive(0, true);
      this.bindRows();
      this.setAttribute('data-pi-ready', '');

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.setAttribute('data-pi-motion', '');
        this.reveal();
      }
    }

    bindRows() {
      this.items.forEach((item, i) => {
        const link = item.querySelector('[data-pi-link]');
        // Hover and focus both select, so the panel follows a keyboard user
        // exactly as it follows a mouse.
        item.addEventListener('pointerenter', () => this.setActive(i));
        link?.addEventListener('focus', () => this.setActive(i));
      });
    }

    setActive(index, initial = false) {
      if (!initial && index === this.active) return;
      const prev = this.active;

      this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));

      this.slides.forEach((slide, i) => {
        slide.classList.remove('was-active');
        if (i === prev && i !== index) slide.classList.add('was-active');
        slide.classList.toggle('is-active', i === index);
      });

      if (this.count) this.count.textContent = String(index + 1).padStart(2, '0');
      this.active = index;
    }

    reveal() {
      const targets = [...this.querySelectorAll('[data-pi-reveal]')];
      targets.forEach((el, i) => el.style.setProperty('--d', `${Math.min(i, 12) * 60}ms`));

      const show = (el) => el.classList.add('is-in');

      if (!('IntersectionObserver' in window)) {
        targets.forEach(show);
        this.panel?.classList.add('is-in');
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            show(entry.target);
            io.unobserve(entry.target);
          }
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );

      targets.forEach((el) => io.observe(el));
      if (this.panel) io.observe(this.panel);

      // Floor, as in the hero: if observers are throttled in a background tab,
      // never leave the list hidden.
      setTimeout(() => {
        targets.forEach(show);
        this.panel?.classList.add('is-in');
      }, 2500);
    }
  }

  if (!customElements.get('sss-print-index')) {
    customElements.define('sss-print-index', SssPrintIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-rail')) {
    class SssRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.progress = this.querySelector('[data-progress]');
        this.current = this.querySelector('[data-current]');
        if (!this.track) return;

        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.lean = 0;
        this.lastX = this.track.scrollLeft;
        this.lastT = performance.now();

        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.setupDrag();
        this.track.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const step = (this.cards[0]?.offsetWidth || 300) + 12;
          this.track.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: 'smooth' });
        });
        this.update();

        // Reveal when the rail comes into view.
        const show = () => this.classList.add('is-in');
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              if (entries.some((e) => e.isIntersecting)) {
                show();
                io.disconnect();
              }
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          io.observe(this);
        }
        setTimeout(show, 2500);
      }

      // Mouse: grab and throw. Touch keeps native scrolling.
      setupDrag() {
        const t = this.track;
        let down = false;
        let moved = false;
        let startX = 0;
        let startScroll = 0;
        let samples = [];

        t.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (e.target.closest('[data-quick]')) return;
          cancelAnimationFrame(this.glide);
          down = true;
          moved = false;
          startX = e.clientX;
          startScroll = t.scrollLeft;
          samples = [{ x: e.clientX, t: performance.now() }];
        });

        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            moved = true;
            t.classList.add('is-dragging');
            t.setPointerCapture?.(e.pointerId);
          }
          if (!moved) return;
          t.scrollLeft = startScroll - dx;
          samples.push({ x: e.clientX, t: performance.now() });
          if (samples.length > 6) samples.shift();
        });

        const release = () => {
          if (!down) return;
          down = false;
          if (!moved) return;
          // Swallow the click that follows a drag so a throw never opens a product.
          t.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
          setTimeout(() => t.classList.remove('is-dragging'), 0);

          const a = samples[0];
          const b = samples[samples.length - 1];
          const dt = Math.max(16, b.t - a.t);
          let v = -((b.x - a.x) / dt) * 16; // px per frame
          if (this.reduced) return;
          const step = () => {
            v *= 0.94;
            if (Math.abs(v) < 0.4) return;
            t.scrollLeft += v;
            this.glide = requestAnimationFrame(step);
          };
          this.glide = requestAnimationFrame(step);
        };

        window.addEventListener('pointerup', release);
        window.addEventListener('pointercancel', release);
      }

      onScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.update();
        });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const p = max > 0 ? t.scrollLeft / max : 1;
        const visible = Math.max(0.08, t.clientWidth / t.scrollWidth);
        this.progress?.style.setProperty('--sss-rail-progress', String(visible + (1 - visible) * p));

        const step = (this.cards[0]?.offsetWidth || 1) + parseFloat(getComputedStyle(t).columnGap || '0');
        // Count the leading card, but land on the last one at the end of the
        // rail, where the final few cards are all in view at once.
        const idx = p >= 0.985 ? this.cards.length : Math.min(this.cards.length, Math.round(t.scrollLeft / step) + 1);
        if (this.current) this.current.textContent = String(idx).padStart(2, '0');

        // Lean into the motion: the faster the rail moves, the further the
        // cards tilt (capped), easing back to flat once it stops.
        if (this.reduced) return;
        const now = performance.now();
        const v = (t.scrollLeft - this.lastX) / Math.max(1, now - this.lastT);
        this.lastX = t.scrollLeft;
        this.lastT = now;
        const lean = Math.max(-7, Math.min(7, -v * 4));
        t.style.setProperty('--sss-rail-lean', lean.toFixed(2) + 'deg');
        t.classList.add('is-moving');
        clearTimeout(this.settle);
        this.settle = setTimeout(() => {
          t.style.setProperty('--sss-rail-lean', '0deg');
          t.classList.remove('is-moving');
        }, 90);
      }
    }

    customElements.define('sss-rail', SssRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-product"]) return;
  try {
    
  if (!customElements.get('sss-pdp')) {
    class SssPdp extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-goto]')];
        this.dots = [...this.querySelectorAll('.sss-pdp__dots span')];
        this.track = this.querySelector('[data-track]');

        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.goto))));

        // Product videos wait on their preview frame: nothing downloads until
        // the play button is pressed. Tapping the video pauses it again, and it
        // pauses by itself when scrolled or swiped away.
        this.querySelectorAll('.sss-pdp__slide--video').forEach((slide) => {
          const video = slide.querySelector('.sss-pdp__video');
          const btn = slide.querySelector('[data-vplay]');
          if (!video || !btn) return;
          const toggle = slide.querySelector('[data-vtoggle]');
          const sync = () => {
            slide.classList.toggle('is-playing', !video.paused);
            toggle?.setAttribute('aria-label', video.paused ? 'Play' : 'Pause');
          };
          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
          const sound = slide.querySelector('[data-vsound]');
          const syncSound = () => {
            if (!sound) return;
            sound.setAttribute('aria-pressed', String(!video.muted));
            sound.setAttribute('aria-label', video.muted ? 'Sound on' : 'Mute');
          };
          // Pressing play starts it with sound (the press lets the browser
          // allow it); the speaker button mutes and unmutes.
          btn.addEventListener('click', () => {
            slide.classList.add('is-started');
            video.preload = 'auto';
            video.muted = false;
            syncSound();
            video.play().catch(() => {
              video.muted = true;
              syncSound();
              video.play().catch(() => {});
            });
          });
          toggle?.addEventListener('click', () => {
            if (video.paused) video.play().catch(() => {});
            else video.pause();
          });
          sound?.addEventListener('click', () => {
            video.muted = !video.muted;
            syncSound();
          });
          video.addEventListener('click', () => { if (!video.paused) video.pause(); });
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(([e]) => { if (!e.isIntersecting) video.pause(); }, { threshold: 0.2 }).observe(video);
          }
        });

        // Desktop: light up the thumbnail of whichever photo fills most of the screen.
        if (this.thumbs.length && 'IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => {
                if (e.isIntersecting) this.setActive(this.slides.indexOf(e.target));
              });
            },
            { rootMargin: '-45% 0px -45% 0px' }
          );
          this.slides.forEach((s) => io.observe(s));
        }

        // Mobile swipe: keep the dots in step with the scroll position.
        this.track?.addEventListener(
          'scroll',
          () => {
            if (!this.track.clientWidth) return;
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
          },
          { passive: true }
        );

        this.querySelectorAll('.sss-pdp__option').forEach((set) => {
          set.querySelectorAll('.sss-pdp__size').forEach((btn) =>
            btn.addEventListener('click', () => {
              set.querySelectorAll('.sss-pdp__size').forEach((b) => {
                b.classList.toggle('is-selected', b === btn);
                b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
              });
              this.updateVariant();
            })
          );
        });

        this.setupSticky();
        this.setupLightbox();

        // Size guide: the glass pop-up.
        const sg = document.getElementById('SssSizeGuide');
        if (sg && !sg.dataset.wired) {
          sg.dataset.wired = '1';
          sg.querySelector('[data-sg-close]')?.addEventListener('click', () => sg.close());
          sg.addEventListener('click', (e) => {
            if (e.target === sg) sg.close();
          });
          const table = sg.querySelector('table');
          table?.addEventListener('mouseover', (e) => {
            const cell = e.target.closest('td, thead th');
            table.querySelectorAll('.is-col').forEach((c) => c.classList.remove('is-col'));
            if (!cell || cell.cellIndex < 1) return;
            table.querySelectorAll('tr').forEach((r) => r.cells[cell.cellIndex]?.classList.add('is-col'));
          });
          table?.addEventListener('mouseleave', () => table.querySelectorAll('.is-col').forEach((c) => c.classList.remove('is-col')));
        }
        this.querySelector('[data-open-guide]')?.addEventListener('click', () => {
          sg?.showModal();
        });

        const show = () => this.classList.add('is-in');
        requestAnimationFrame(() => requestAnimationFrame(show));
        setTimeout(show, 600);
      }

      goTo(i) {
        const slide = this.slides[i];
        if (!slide) return;
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.setActive(i);
      }

      setActive(i) {
        this.thumbs.forEach((t, n) => {
          t.classList.toggle('is-active', n === i);
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }

      /* ---- Sticky Add to Cart (phones) ---- */
      setupSticky() {
        const bar = document.getElementById('SssStickyBuy');
        const form = this.querySelector('.sss-pdp__form');
        if (!bar || !form || bar.dataset.wired) return;
        bar.dataset.wired = '1';
        this.sticky = bar;

        const select = bar.querySelector('[data-sticky-size]');
        select?.addEventListener('change', () => {
          this.querySelector(`.sss-pdp__option .sss-pdp__size[data-value="${CSS.escape(select.value)}"]`)?.click();
        });
        bar.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
          this.querySelector('.sss-pdp__form .add-to-cart-button')?.click();
        });

        const show = (on) => {
          bar.classList.toggle('is-visible', on);
          bar.setAttribute('aria-hidden', String(!on));
          bar.querySelectorAll('select, button').forEach((el) => (el.tabIndex = on ? 0 : -1));
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(([entry]) => {
            // Only once the real button has scrolled away above the screen.
            show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          }).observe(form);
        }
      }

      syncSticky(v) {
        const bar = this.sticky;
        if (!bar || !v) return;
        const price = bar.querySelector('[data-sticky-price]');
        if (price) price.textContent = v.available ? v.price : 'Sold out';
        const select = bar.querySelector('[data-sticky-size]');
        if (select && v.options?.[0] != null) select.value = v.options[0];
        const add = bar.querySelector('[data-sticky-add]');
        if (add) add.disabled = !v.available;
      }

      /* ---- Photo viewer ---- */
      setupLightbox() {
        const lb = document.getElementById('SssLightbox');
        if (!lb || lb.dataset.wired) return;
        lb.dataset.wired = '1';
        const track = lb.querySelector('[data-lb-track]');
        const slides = [...lb.querySelectorAll('[data-lb-slide]')];
        const current = lb.querySelector('[data-lb-current]');
        const unzoom = () => {
          slides.forEach((s) => s.classList.remove('is-zoomed'));
          lb.classList.remove('is-zoomed');
        };
        const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        const go = (i, smooth = true) => {
          unzoom();
          const n = Math.max(0, Math.min(slides.length - 1, i));
          track.scrollTo({ left: n * track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
        };

        this.querySelectorAll('[data-zoom]').forEach((fig) =>
          fig.addEventListener('click', () => {
            slides.forEach((s) => s.querySelector('img')?.setAttribute('loading', 'eager'));
            lb.showModal();
            requestAnimationFrame(() => go(Number(fig.dataset.zoom), false));
            if (current) current.textContent = String(Number(fig.dataset.zoom) + 1);
          })
        );

        track.addEventListener('scroll', () => {
          if (current) current.textContent = String(index() + 1);
        }, { passive: true });

        lb.querySelectorAll('[data-lb-step]').forEach((b) =>
          b.addEventListener('click', () => go(index() + Number(b.dataset.lbStep)))
        );
        lb.querySelector('[data-lb-close]')?.addEventListener('click', () => lb.close());
        lb.addEventListener('close', unzoom);
        lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') go(index() + 1);
          if (e.key === 'ArrowLeft') go(index() - 1);
        });

        // Tap to zoom in at that point, tap again to zoom out; while zoomed,
        // moving the pointer (or dragging a finger) looks around the photo.
        slides.forEach((slide) => {
          const img = slide.querySelector('img');
          let moved = false;
          slide.addEventListener('pointerdown', () => (moved = false));
          slide.addEventListener('pointermove', (e) => {
            if (!slide.classList.contains('is-zoomed')) return;
            if (e.pointerType !== 'mouse' && e.buttons === 0) return;
            moved = true;
            if (img) {
              const r = slide.getBoundingClientRect();
              img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
            }
          });
          slide.addEventListener('click', (e) => {
            if (moved && e.pointerType !== 'mouse') return;
            const zoom = !slide.classList.contains('is-zoomed');
            unzoom();
            if (zoom) {
              if (img) {
                const r = slide.getBoundingClientRect();
                img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
              }
              slide.classList.add('is-zoomed');
              lb.classList.add('is-zoomed');
            }
          });
        });
      }

      updateVariant() {
        const chosen = [...this.querySelectorAll('.sss-pdp__option')].map(
          (set) => set.querySelector('.sss-pdp__size.is-selected')?.dataset.value
        );
        const v = this.variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        if (!v) return;

        const input = this.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (input) input.value = v.id;

        const btn = this.querySelector('.add-to-cart-button');
        if (btn) btn.disabled = !v.available;

        this.style.setProperty('--sss-atc-price', JSON.stringify(v.available ? v.price : 'Sold out'));

        const price = this.querySelector('[data-price]');
        if (price) {
          price.innerHTML = (v.compare ? `<s>${v.compare}</s>` : '') + `<span>${v.price}</span>`;
        }

        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
        this.syncSticky(v);
      }
    }

    customElements.define('sss-pdp', SssPdp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-size-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-size-guide')) {
    class SssSizeGuide extends HTMLElement {
      connectedCallback() {
        try {
          this.sizes = JSON.parse(this.querySelector('[data-sizes]').textContent);
        } catch (e) {
          return;
        }
        if (!this.sizes.length) return;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.keys = ['chest', 'waist', 'hip'];

        // The whole run of each measurement, for the bars.
        this.scale = {};
        this.keys.forEach((k) => {
          const lo = Math.min(...this.sizes.map((s) => s[k][0]));
          const hi = Math.max(...this.sizes.map((s) => s[k][1]));
          this.scale[k] = [lo, hi];
          const card = this.querySelector(`.sgp__card[data-card="${k}"]`);
          if (card) {
            card.querySelector('[data-lo]').textContent = lo;
            card.querySelector('[data-hi]').textContent = hi;
          }
        });

        this.toggle = this.querySelector('.sgp__toggle');
        this.querySelectorAll('[data-size]').forEach((el) =>
          el.addEventListener('click', () => this.select(Number(el.dataset.size), true))
        );

        // Arrow keys move through the sizes, as a radio group.
        this.toggle?.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const next = (this.current + (e.key === 'ArrowRight' ? 1 : -1) + this.sizes.length) % this.sizes.length;
          this.select(next, true);
          this.toggle.querySelectorAll('.sgp__size')[next]?.focus();
        });

        // Hovering a card or a how-to row lights its line on the photograph.
        this.querySelectorAll('[data-card]').forEach((card) => {
          card.addEventListener('mouseenter', () => (this.dataset.focus = card.dataset.card));
          card.addEventListener('mouseleave', () => delete this.dataset.focus);
        });

        this.select(Number(this.dataset.default) || 0, false);
        this.setupReveal();
      }

      select(index, animate) {
        const size = this.sizes[index];
        if (!size) return;
        const previous = this.current;
        this.current = index;

        if (this.toggle) {
          this.toggle.style.setProperty('--i', String(index));
          this.toggle.querySelectorAll('.sgp__size').forEach((b, i) => {
            b.setAttribute('aria-checked', String(i === index));
            b.tabIndex = i === index ? 0 : -1;
          });
          if (animate && previous !== index && !this.reduced) {
            this.toggle.classList.remove('is-moving');
            void this.toggle.offsetWidth;
            this.toggle.classList.add('is-moving');
          }
        }

        this.keys.forEach((k) => {
          const [lo, hi] = size[k];
          const [min, max] = this.scale[k];
          const span = max - min || 1;
          const card = this.querySelector(`.sgp__card[data-card="${k}"]`);
          if (card) {
            const bar = card.querySelector('[data-bar]');
            bar.style.setProperty('--lo', `${((lo - min) / span) * 100}%`);
            bar.style.setProperty('--hi', `${((hi - min) / span) * 100}%`);
            const range = card.querySelector('[data-range]');
            const from = previous != null ? this.sizes[previous][k] : [lo, hi];
            this.tween(range, from, [lo, hi], animate);
          }
          const tag = this.querySelector(`[data-tag="${k}"] [data-tag-val]`);
          if (tag) tag.textContent = `${lo}–${hi}`;
        });

        this.querySelectorAll('.sgp__table [data-col]').forEach((cell) =>
          cell.classList.toggle('is-col', Number(cell.dataset.col) === index)
        );
      }

      /* Count the figures from the old size's range to the new one. */
      tween(el, from, to, animate) {
        const write = (a, b) => (el.textContent = `${Math.round(a)}–${Math.round(b)}`);
        if (!animate || this.reduced) return write(to[0], to[1]);
        const start = performance.now();
        const dur = 450;
        const step = (t) => {
          const k = Math.min(1, (t - start) / dur);
          const e = 1 - Math.pow(1 - k, 3);
          write(from[0] + (to[0] - from[0]) * e, from[1] + (to[1] - from[1]) * e);
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        setTimeout(() => write(to[0], to[1]), dur + 150);
      }

      setupReveal() {
        const items = [...this.querySelectorAll('[data-reveal]')];
        const show = (el) => el.classList.add('is-in');
        if (this.reduced || !('IntersectionObserver' in window)) return items.forEach(show);
        const io = new IntersectionObserver(
          (entries) => entries.forEach((e) => {
            if (e.isIntersecting) {
              show(e.target);
              io.unobserve(e.target);
            }
          }),
          { rootMargin: '0px 0px -10% 0px' }
        );
        items.forEach((el) => io.observe(el));
        setTimeout(() => items.forEach(show), 2500);
      }
    }

    customElements.define('sss-size-guide', SssSizeGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-statement"] && !Shopify.designMode) return;
  try {
    
  class SssStatement extends HTMLElement {
    connectedCallback() {
      this.words = [...this.querySelectorAll('[data-st-word]')];
      this.line = this.querySelector('.sss-st__word.is-line');
      this.sun = this.querySelector('.sss-st__word.is-sun');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.warmth = 1;

      this.setupField();
      if (!this.words.length || this.reduced) return;

      // Faint, not invisible: the whole sentence is legible as a shape from
      // the start, and the fill only adds emphasis as you read.
      this.floor = 0.16;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };

      // Dwell scrolls the page inside .page-wrapper rather than the window, so
      // a scroll listener on window never fires. Scroll events do not bubble,
      // but a capturing listener on document receives them from any scrolling
      // element — this works whichever element ends up being the scroller.
      document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.onScroll, { capture: true });
      window.removeEventListener('resize', this.onScroll);
      this.io?.disconnect();
      this.ro?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    update() {
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      const clamp = (v) => Math.min(1, Math.max(0, v));

      // 0 when the section's top reaches 85% of the viewport, 1 when it
      // reaches 15%. The words fill over the first 60%; the rule draws under
      // its word as that word lands, then breaks into dots; the sun word warms
      // last.
      const progress = clamp((vh * 0.85 - rect.top) / (vh * 0.7));
      const lit = clamp(progress / 0.6) * this.words.length;

      this.words.forEach((word, i) => {
        const amount = clamp(lit - i);
        word.style.setProperty('--o', (this.floor + (1 - this.floor) * amount).toFixed(3));
      });

      if (this.line) {
        const draw = clamp((progress - 0.26) / 0.2);
        const dots = clamp((progress - 0.5) / 0.18);
        this.line.style.setProperty('--draw', draw.toFixed(3));
        this.line.style.setProperty('--r', `${(8 - 6.1 * dots).toFixed(2)}px`);
      }

      this.warmth = clamp((progress - 0.68) / 0.22);
      this.sun?.style.setProperty('--sun', this.warmth.toFixed(3));
    }

    /* ---- The perforation field ---- */
    setupField() {
      const canvas = this.querySelector('[data-st-field]');
      if (!canvas) return;
      this.canvas = canvas;
      this.ctx = canvas.getContext('2d');
      this.light = { x: 0, y: 0 };
      this.target = { x: 0, y: 0 };
      this.hovering = false;
      this.running = false;

      const resize = () => {
        const r = canvas.getBoundingClientRect();
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        this.w = r.width;
        this.h = r.height;
        canvas.width = Math.round(r.width * dpr);
        canvas.height = Math.round(r.height * dpr);
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        if (!this.placed) {
          this.light = { x: this.w * 0.5, y: this.h * 0.5 };
          this.placed = true;
        }
        this.draw();
      };
      this.ro = new ResizeObserver(resize);
      this.ro.observe(canvas);

      if (this.reduced) return;

      // The light follows the cursor anywhere over the section, so it already
      // moves as the reader comes across from the text.
      this.addEventListener('pointermove', (e) => {
        const r = canvas.getBoundingClientRect();
        this.target = { x: e.clientX - r.left, y: e.clientY - r.top };
        this.hovering = true;
      });
      this.addEventListener('pointerleave', () => (this.hovering = false));

      const loop = (t) => {
        if (!this.running) return;
        if (!this.hovering) {
          // No cursor: the light drifts slowly round the field on its own.
          this.target = {
            x: this.w * (0.5 + 0.26 * Math.sin(t / 4200)),
            y: this.h * (0.5 + 0.2 * Math.sin(t / 3100 + 1)),
          };
        }
        this.light.x += (this.target.x - this.light.x) * 0.08;
        this.light.y += (this.target.y - this.light.y) * 0.08;
        this.draw();
        this.frame = requestAnimationFrame(loop);
      };

      // Only animate while the section is on screen.
      this.io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !this.running) {
          this.running = true;
          this.frame = requestAnimationFrame(loop);
        } else if (!entry.isIntersecting) {
          this.running = false;
          cancelAnimationFrame(this.frame);
        }
      });
      this.io.observe(this);
    }

    draw() {
      const { ctx, w, h } = this;
      if (!ctx || !w || !h) return;
      ctx.clearRect(0, 0, w, h);

      const gap = 14;
      const reach = Math.max(140, Math.min(260, Math.min(w, h) * 0.5));
      const strength = 0.45 + 0.55 * this.warmth;
      const { x: lx, y: ly } = this.light;

      // Sunlight: a warm pool behind the dots.
      const glow = ctx.createRadialGradient(lx, ly, 0, lx, ly, reach * 1.25);
      glow.addColorStop(0, `rgba(232, 186, 110, ${0.3 * strength})`);
      glow.addColorStop(1, 'rgba(232, 186, 110, 0)');
      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, w, h);

      // The dots: faint ink, turning gold and growing as the light reaches
      // them. Unlit dots go in one path; lit ones are drawn one by one.
      const ox = (w % gap) / 2;
      const oy = (h % gap) / 2;
      ctx.fillStyle = 'rgba(36, 30, 24, 0.2)';
      ctx.beginPath();
      const lit = [];
      for (let y = oy; y <= h; y += gap) {
        for (let x = ox; x <= w; x += gap) {
          const d = Math.hypot(x - lx, y - ly);
          const k = d < reach ? (1 - d / reach) ** 2 * strength : 0;
          if (k < 0.03) {
            ctx.moveTo(x + 1.1, y);
            ctx.arc(x, y, 1.1, 0, Math.PI * 2);
          } else {
            lit.push(x, y, k);
          }
        }
      }
      ctx.fill();

      for (let i = 0; i < lit.length; i += 3) {
        const k = lit[i + 2];
        ctx.fillStyle = `rgba(184, 150, 90, ${(0.3 + 0.7 * k).toFixed(3)})`;
        ctx.beginPath();
        ctx.arc(lit[i], lit[i + 1], 1.1 + 1.9 * k, 0, Math.PI * 2);
        ctx.fill();
      }
    }
  }

  if (!customElements.get('sss-statement')) {
    customElements.define('sss-statement', SssStatement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sss-sun"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sss-sun')) {
    class SssSun extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-frame]');
        this.sun = this.querySelector('[data-sun]');
        this.spots = [...this.querySelectorAll('[data-spot]')].map((el) => ({
          el,
          x: parseFloat(el.style.getPropertyValue('--x')),
          y: parseFloat(el.style.getPropertyValue('--y')),
        }));
        this.notes = [...this.querySelectorAll('[data-note]')];
        if (!this.frame || !this.sun) return;

        this.pos = { x: 50, y: 45 };
        this.user = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.place(this.pos.x, this.pos.y);

        const toPct = (e) => {
          const r = this.frame.getBoundingClientRect();
          return {
            x: Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)),
            y: Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100)),
          };
        };

        // Mouse: the sun follows the cursor over the photo.
        this.frame.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.takeOver();
          this.frame.classList.remove('is-gliding');
          const p = toPct(e);
          this.move(p.x, p.y);
        });

        // Touch: drag the sun itself, or tap the photo / a spot.
        this.sun.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse') return;
          this.takeOver();
          this.dragging = true;
          this.sun.setPointerCapture(e.pointerId);
        });
        this.sun.addEventListener('pointermove', (e) => {
          if (!this.dragging) return;
          const p = toPct(e);
          this.move(p.x, p.y);
        });
        const end = () => (this.dragging = false);
        this.sun.addEventListener('pointerup', end);
        this.sun.addEventListener('pointercancel', end);
        this.frame.addEventListener('click', (e) => {
          if (e.target.closest('[data-sun]')) return;
          this.takeOver();
          const spot = e.target.closest('[data-spot]');
          if (spot) {
            const s = this.spots[Number(spot.dataset.spot)];
            this.glideTo(s.x, s.y);
            return;
          }
          const p = toPct(e);
          this.glideTo(p.x, p.y);
        });

        this.sun.addEventListener('keydown', (e) => {
          const step = e.shiftKey ? 8 : 3;
          const d = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] }[e.key];
          if (!d) return;
          e.preventDefault();
          this.takeOver();
          this.move(this.pos.x + d[0], this.pos.y + d[1]);
        });

        // The lists at the sides: hovering, focusing or tapping a line sends
        // the sun to that feature's spot.
        this.notes.forEach((n) => {
          const go = () => {
            const s = this.spots[Number(n.dataset.note)];
            if (!s) return;
            this.takeOver();
            this.glideTo(s.x, s.y);
          };
          n.addEventListener('mouseenter', go);
          n.addEventListener('focus', go);
          n.addEventListener('click', go);
        });

        // Drift on its own until someone takes over.
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              const vis = entries.some((en) => en.isIntersecting);
              if (vis && !this.user) this.startDrift();
              else this.stopDrift();
            },
            { threshold: 0.3 }
          );
          io.observe(this.frame);
        }
      }

      takeOver() {
        if (this.user) return;
        this.user = true;
        this.stopDrift();
      }

      startDrift() {
        if (this.reduced || this.drift) return;
        const t0 = performance.now();
        const tick = (t) => {
          const s = (t - t0) / 1000;
          // A slow figure-of-eight across the body.
          this.move(50 + Math.sin(s * 0.4) * 26, 52 + Math.sin(s * 0.8) * 22);
          this.drift = requestAnimationFrame(tick);
        };
        this.drift = requestAnimationFrame(tick);
      }

      stopDrift() {
        cancelAnimationFrame(this.drift);
        this.drift = 0;
      }

      // Glide: set the target straight away (so the right card opens at
      // once) and let CSS animate the sun there.
      glideTo(x, y) {
        if (!this.reduced) this.frame.classList.add('is-gliding');
        this.move(x, y);
        clearTimeout(this.glideEnd);
        this.glideEnd = setTimeout(() => this.frame.classList.remove('is-gliding'), 600);
      }

      place(x, y) {
        this.pos = { x, y };
        this.frame.style.setProperty('--sx', x + '%');
        this.frame.style.setProperty('--sy', y + '%');
      }

      move(x, y) {
        this.place(Math.max(0, Math.min(100, x)), Math.max(0, Math.min(100, y)));
        // Open whichever feature the sun is over; light its line in the list.
        let litIndex = -1;
        let best = 9;
        this.spots.forEach((s, i) => {
          const d = Math.hypot(s.x - this.pos.x, s.y - this.pos.y);
          if (d < best) {
            best = d;
            litIndex = i;
          }
        });
        this.spots.forEach((s, i) => s.el.classList.toggle('is-lit', i === litIndex));
        this.notes.forEach((n) => n.classList.toggle('is-active', Number(n.dataset.note) === litIndex));
      }
    }

    customElements.define('sss-sun', SssSun);
  }

  } catch(e) { console.error(e); }
})();
})();
